<template>
  <div>
    <v-list-tile v-if="loading">
      <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
    </v-list-tile>
    <v-list-tile v-else avatar @click="openDialogUpdate()">
      <v-list-tile-avatar>
        <v-icon class="primary white--text">short_text</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>{{ sentence.title }}</v-list-tile-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-menu bottom left>
          <v-btn icon="icon" slot="activator" @mouseover.native="overMenu = true" @mouseleave.native="overMenu = false">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list dense>
            <v-list-tile @click="openDialogUpdate()">
              <v-list-tile-action>
                <v-icon>edit</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('edit') | cap }} {{ $tc('sentences', 1) }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="openDialogMove()">
              <v-list-tile-action>
                <v-icon>move_to_inbox</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('move') | cap }} {{ $tc('sentences', 1) }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="openDialogDelete()">
              <v-list-tile-action>
                <v-icon>delete</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('delete') | cap }} {{ $tc('sentences', 1) }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-list-tile-action>
    </v-list-tile>

    <v-dialog v-model="showDialogUpdate" max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('edit') | cap }} {{ $tc('sentences', 1) }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-textarea 
            label="Modifiez votre phrase" 
            v-model="sentenceDialog.title"
            required
            data-vv-name="sentenceInput"
            v-validate="'required'"
            :error="wzErrors.has('sentenceInput')"
            :errors="wzErrors.collect('sentenceInput')"
          ></v-textarea>
          <small>*{{ $t('required') }}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn flat @click="showDialogUpdate = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" :disabled="wzErrors.any()" @click="submitDialogUpdate">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogMove" max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('move') | cap }} {{ $tc('sentences', 1) }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-select
              label="Choissisez la Bibliothèque"
              v-model="biblioSelectId"
              :items="$store.getters['_Biblios/GET_BIBLIO_TITLE']"
              required
            ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn flat @click="showDialogMove = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" @click="submitDialogMove">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogDelete" max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('delete') | cap }} {{ $tc('sentences', 1) }}</v-card-title>
        <v-card-text>
          {{ $t('delete') | cap }} {{ $tc('sentences', 1) }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn flat @click.native="showDialogDelete = false">{{ $t('no') }}</v-btn>
          <v-btn color="primary" @click.native="submitDialogDelete">{{ $t('yes') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import _ from 'lodash'

export default {

  props: {
    biblio: {
      type: Object,
      required: true
    },
    sentence: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      /**
       * affiche/cache la fenetre de dialog de modification
       * @type {Boolean}
       */
      showDialogUpdate: false,
      /**
       * affiche/cache la fenetre de dialog de suppression
       * @type {Boolean}
       */
      showDialogDelete: false,
      /**
       * affiche/cache la fenetre de dialog de déplacement
       * @type {Boolean}
       */
      showDialogMove: false,
      /**
       * phrase qui sera utilisée dans la fenêtre de dialogue de modification
       * @type {Object}
       */
      sentenceDialog: {},
      /**
       * Identifiant de la bibliothèque qui est manipulée dans le select
       */
      biblioSelectId: this.biblio.id,
      loading: false,
      overMenu: false
    }
  },

  methods: {
    openDialogUpdate () {
      if (!this.overMenu) {
        this.sentenceDialog = _.clone(this.sentence)
        this.showDialogUpdate = true
      }
    },
    openDialogMove () {
      this.sentenceDialog = _.clone(this.sentence)
      this.showDialogMove = true
    },
    openDialogDelete () {
      this.sentenceDialog = _.clone(this.sentence)
      this.showDialogDelete = true
    },
    submitDialogUpdate () {
      this.showDialogUpdate = false
      // s'il y a bien eu une modification
      if ((this.sentence.title !== this.sentenceDialog.title)) {
        // recherche de la phrase dans la biblio
        // si elle n'est pas trouvée alors on peut la modifier
        let sentenceFound = _.find(this.biblio.sentences, { 'title': this.sentenceDialog.title })
        if (_.isNil(sentenceFound)) {
          let dataToPost = new window.FormData()
          dataToPost.append('SEN_ID', this.sentence.id)
          dataToPost.append('SEN_MSG', this.sentenceDialog.title)
          dataToPost.append('SEN_FAM_ID', this.biblio.id)
          this.loading = true
          this.axios.post('put/sentence.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
          .then(response => {
            // modification de la biblio dans la liste des bibliothèques
            let biblioUpdate = _.cloneDeep(this.biblio)
            let sentencesUpdate = []
            for (var i = 0; i < biblioUpdate.sentences.length; i++) {
              // si la phrase passée en paramètre correspond à une existante
              // alors changement de titre pour cette phrase
              if (biblioUpdate.sentences[i].id === this.sentenceDialog.id) {
                sentencesUpdate.push(this.sentenceDialog)
              } else {
                sentencesUpdate.push(biblioUpdate.sentences[i])
              }
            }
            biblioUpdate.sentences = sentencesUpdate
            this.$store.commit('_Biblios/UPDATE_BIBLIO', biblioUpdate)
            this.$emit('update:biblio', biblioUpdate)
            // Notification
            this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
          })
          .catch(_ => {
            this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
          })
          .then(_ => {
            this.loading = false
          })
        } else {
          // Notification
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('alreadyExists'), context: 'warning' })
        }
      }
    },
    submitDialogMove () {
      this.showDialogMove = false
      // il y a eu changement dans le select (i.e. ce n'est pas la même bibliothèque qui est sélectionnée)
      if (this.biblioSelectId !== this.biblio.id) {
        let dataToPost = new window.FormData()
        dataToPost.append('SEN_ID', this.sentence.id)
        dataToPost.append('SEN_MSG', this.sentence.title)
        dataToPost.append('SEN_FAM_ID', this.biblioSelectId)
        this.loading = true
        this.axios.post('put/sentence.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          // ajout de la phrase dans la biblio pointée par le select
          let biblioUpdate = _.cloneDeep(this.$store.getters['_Biblios/GET_BIBLIO_BY_ID'](this.biblioSelectId))
          biblioUpdate.sentences.push(this.sentence)
          this.$store.commit('_Biblios/UPDATE_BIBLIO', biblioUpdate)
          // suppression de la phrase dans la biblio actuelle
          this.$emit('update:biblio', this.deleteSentence())
          // Notification
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'Phrase déplacée dans la bibliothèque ' + biblioUpdate.title,
            context: 'success',
            action: { text: `S'y rendre`, path: '/media/biblios/' + biblioUpdate.id }
          })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
        })
        .then(_ => {
          this.loading = false
        })
      }
    },
    submitDialogDelete () {
      this.showDialogDelete = false
      let dataToPost = new window.FormData()
      dataToPost.append('SEN_ID', this.sentence.id)
      this.loading = true
      this.axios.post('delete/sentence.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        // suppression de la phrase dans la liste des phrases
        this.$emit('update:biblio', this.deleteSentence())
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('deleteSuccess'), context: 'success' })
      })
      .catch(_ => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('deleteFailure'), context: 'error' })
      })
      .then(_ => {
        this.loading = false
      })
    },
    deleteSentence () {
      let biblioUpdate = _.cloneDeep(this.biblio)
      // suppression de la phrase dans la bibliothèque
      let sentencesUpdate = _.differenceWith(this.biblio.sentences, [this.sentenceDialog], _.isEqual)
      // actualisation des phrases de la bibliothèque
      biblioUpdate.sentences = sentencesUpdate
      this.$store.commit('_Biblios/UPDATE_BIBLIO', biblioUpdate)
      return biblioUpdate
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzSentence.vue